import type { IProjectGridRowsSliceState } from '.';

export function updateTreeVersion(state: IProjectGridRowsSliceState, projectId: string) {
  state.treeVersion[projectId] = (state.treeVersion[projectId] ?? 0) + 1;
  return state;
}
